import { render, staticRenderFns } from "./UOttawaLabExamPt1Fr.vue?vue&type=template&id=9fdba3dc&scoped=true&"
import script from "./UOttawaLabExamPt1Fr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExamPt1Fr.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExamPt1Fr.vue?vue&type=style&index=0&id=9fdba3dc&prod&lang=css&"
import style1 from "./UOttawaLabExamPt1Fr.vue?vue&type=style&index=1&id=9fdba3dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdba3dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
